import { render, staticRenderFns } from "./uni-number-box.vue?vue&type=template&id=b24a5e44&"
import script from "./uni-number-box.vue?vue&type=script&lang=js&"
export * from "./uni-number-box.vue?vue&type=script&lang=js&"
import style0 from "./uni-number-box.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports